export const CHANGE_BANK_LABEL = 'Change';

export const DATA_TEST_IDS = {
  BANK_NAME: 'bank-name-at-summary-page',
  ACCOUNT_MASK: 'account-mask-at-summary-page',
  CHANGE_BANK_BUTTON: 'change-bank-at-summary-page-button',
};

export const PAYING_WITH_LABEL = 'Paying with';
